export default (function (diameter) {
  return "\n  width: ".concat(diameter, "px;\n  height: ").concat(diameter, "px;\n  border-radius: ").concat(diameter / 2, "px;\n");
});